import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllBanks = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/banks',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveBank = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/banks',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateBank = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/banks/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteBank = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/banks/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllBanks,
  saveBank,
  deleteBank,
  updateBank,
}
